module.exports = __webpack_public_path__ + "static/img/rl.4f431a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_colorful/rl.svg
// module id = LvYz
// module chunks = 35